// errJa — map online wire ErrCodes (and welcome ok:false error codes) to Japanese UI text. Shared by the
// board (SoloMahjong fatal modal / error toast) and the WaitingRoom (config-reject / terminal display).
export const ERR_JA: Record<string, string> = {
  ROOM_NOT_FOUND: '部屋が見つかりません',
  BAD_SEAT_TICKET: '座席チケットが無効です',
  TICKET_EXPIRED: '座席チケットの有効期限が切れました',
  TICKET_REPLAY: '座席チケットが既に使用されています',
  PROTOCOL_MISMATCH: 'サーバとバージョンが一致しません',
  SEAT_TAKEN: 'その席は既に使用されています',
  ROOM_STARTED: 'この部屋は既に対局開始済みです',
  NOT_HOST: 'ホストのみが操作できます',
  ROOM_FULL: '部屋が満席です',
  NOT_YOUR_TURN: 'あなたの手番ではありません',
  ILLEGAL_MOVE: 'その操作はできません',
  RATE_LIMITED: '操作が多すぎます。しばらく待ってください',
  AUTH_REQUIRED: 'サインインが必要です',
  INTERNAL: 'サーバエラーが発生しました',
};

export function errJa(code: string): string {
  return ERR_JA[code] ?? code;
}
